"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LivingRoomOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="M8.442 18.202c-.5 0-.907.39-.907.873s.406.875.907.875h14.663c.5 0 .907-.392.907-.874 0-.483-.406-.874-.907-.874H8.442Z"></path><path fill-rule="evenodd" d="M29 12.892c0-1.288-1.083-2.331-2.419-2.331v-4.23C26.581 5.043 25.498 4 24.163 4H8.442C7.106 4 6.023 5.043 6.023 6.33v4.231H5.42c-1.337 0-2.42 1.043-2.42 2.33v14.235c0 .483.406.874.907.874s.907-.391.907-.874v-2.582h22.372v2.582c0 .483.406.874.907.874.5 0 .907-.391.907-.874V12.89ZM4.814 22.796h22.372v-9.904a.594.594 0 0 0-.605-.583h-1.814V6.33a.594.594 0 0 0-.604-.583H8.442a.594.594 0 0 0-.605.583v5.978H5.42a.594.594 0 0 0-.605.583v9.904Z" clip-rule="evenodd"></path></g>';
var LivingRoomOutlineSVG = function LivingRoomOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LivingRoomOutlineSVG = LivingRoomOutlineSVG;
LivingRoomOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LivingRoomOutlineSVG);
exports.default = _default;